import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import classNames from "classnames";
import * as Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsReact from "highcharts-react-official";
import styleConstants from "../../styleConstants";

HighchartsMore(Highcharts);

const plotAreaHorizontalMargin = 5;

const styles = {
  container: {
    fontSize: "0.75rem"
  }
};

const WaterfallChart = props => {
  let options = {
    chart: {
      type: "waterfall",
      backgroundColor: null,
      style: {
        fontFamily: "'Source Sans Pro', sans-serif;"
      },
      marginLeft: props.marginLeft + plotAreaHorizontalMargin,
      marginRight: plotAreaHorizontalMargin,
      width: props.width,
      height: 300
    },
    title: {
      text: props.title,
      style: {
        fontSize: "0.75rem"
      },
      x: props.yAxis.showLabels ? 28 : undefined
    },
    plotOptions: {
      waterfall: {
        groupPadding: 0,
        pointPadding: 0
      }
    },
    xAxis: {
      categories: ["2020", "", "", "2030"],
      labels: {
        autoRotation: false,
        style: {
          fontSize: "0.875rem",
          color: styleConstants.colors.gray4
        }
      },
      lineColor: styleConstants.colors.gray6
    },
    yAxis: {
      title: {
        text: props.yAxis.title
      },
      min: props.yAxis.minimum,
      max: props.yAxis.maximum,
      labels: {
        formatter: function() {
          return `${this.value * 100}%`;
        },
        style: {
          fontSize: "0.875rem",
          color: styleConstants.colors.gray4
        },
        enabled: props.yAxis.showLabels
      },
      gridLineDashStyle: "ShortDot",
      gridLineColor: styleConstants.colors.gray4
    },
    series: props.series,
    tooltip: {
      backgroundColor: "white",
      useHTML: true,
      outside: true,
      formatter: props.tooltipFormatter,
      style: {
        fontSize: "0.875rem",
        color: styleConstants.colors.gray6
      },
      enabled: !!props.tooltipFormatter
    },
    legend: {
      enabled: false
    },
    exporting: {
      enabled: false
    },
    credits: {
      enabled: false
    }
  };

  return (
    <div className={classNames(props.classes.container, props.className)}>
      <HighchartsReact
        ref={props.onRegisterChartRef}
        highcharts={Highcharts}
        options={options}
      />
    </div>
  );
};

WaterfallChart.propTypes = {
  title: PropTypes.string,
  marginLeft: PropTypes.number,
  width: PropTypes.number.isRequired,
  yAxis: PropTypes.shape({
    title: PropTypes.string,
    minimum: PropTypes.number,
    maximum: PropTypes.number,
    showLabels: PropTypes.bool
  }),
  series: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      data: PropTypes.arrayOf(
        PropTypes.shape({
          y: PropTypes.number.isRequired,
          isSum: PropTypes.bool
        })
      ).isRequired
    })
  ).isRequired,
  tooltipFormatter: PropTypes.func,
  className: PropTypes.string,
  onRegisterChartRef: PropTypes.func
};

WaterfallChart.defaultProps = {
  yAxis: {},
  tooltipFormatter: function(tooltip) {
    return tooltip.defaultFormatter.call(this, tooltip);
  }
};

export default withStyles(styles)(WaterfallChart);
